async function  getRawDocument(id,config={}){
  config = { ...this._config, ...config };
  const uri = this._uriConstructor(null, 'raw-documentation');
  return this._http.get(`${uri}/${id}`, config);
}


export default getRawDocument
